import { Autocomplete, TextField, Typography } from '@mui/material';
import {
  StyledDialog,
  StyledDialogActions,
  StyledDialogContent,
  StyledDialogTitle
} from '../../atoms/styledModal';
import UserAccessItem from './UserAccessItem/UserAccessItem';
import StyledInput from '../../atoms/StyledInput';
import { InputLabel, InputGroup, InputContainer } from './modalStyles';
import { useState } from 'react';
import GroupRoleEnum from '../../../enums/GroupRoleEnum';
import { createGroupsInCompany } from '../../../api/group-setting';
import toast from 'react-hot-toast';
import AnimatedDotsText from '../../atoms/AnimatedDotsText';
import StyledButton from '../../atoms/StyledButton';

function CreateGroupModal({ open, onClose, companyMembers, onCreateSuccess }) {
  const [group, setGroup] = useState({
    groupName: '',
    members: []
  });
  const [loading, setLoading] = useState(false);

  const handleGroupNameChange = (e) => {
    setGroup({ ...group, groupName: e.target.value });
  };

  const handelCreateGroupConfirm = async () => {
    setLoading(true);
    try {
      const createGroupRes = await createGroupsInCompany(group);
      const newGroup = {
        _id: createGroupRes?.data?.group_id,
        name: group.groupName,
        members: group.members
      };
      onCreateSuccess?.(newGroup);
      setGroup({ groupName: '', members: [] });
      onClose();
      toast.success(createGroupRes?.data?.message);
    } catch (e) {
      const { error = '', message = '' } = e?.response?.data || {};
      toast.error(error || message);
    } finally {
      setLoading(false);
    }
  };

  const handleRoleChange = (index, newRole) => {
    const updatedMembers = [...group.members];
    updatedMembers[index].role = newRole;
    setGroup({ ...group, members: updatedMembers });
  };

  const removeMember = (index) => {
    const updatedMembers = group.members.filter((_, i) => i !== index);
    setGroup({ ...group, members: updatedMembers });
  };
  
  const addMember = (event, selectedOption) => {
    if (selectedOption?.name && selectedOption?.email && selectedOption?._id) {
      const memberExists = group.members.some((member) => member._id === selectedOption._id);

      if (!memberExists) {
        const newMember = {
          _id: selectedOption._id,
          name: selectedOption.name,
          email: selectedOption.email,
          role: GroupRoleEnum.GROUP_MEMBER
        };
        setGroup({ ...group, members: [...group.members, newMember] });
      }
    }
  };

  return (
    <StyledDialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <StyledDialogTitle>Create Group</StyledDialogTitle>
      <StyledDialogContent>
        <InputContainer>
          <InputGroup>
            <InputLabel>Group Name</InputLabel>
            <StyledInput
              onChange={handleGroupNameChange}
              fullWidth
              placeholder="Name"
              value={group.groupName}
            />
          </InputGroup>
          <InputGroup>
            <InputLabel>Add User</InputLabel>
            <Autocomplete
              size="small"
              fullWidth
              placeholder="Add group members by email or name"
              onChange={addMember}
              renderInput={(params) => <TextField {...params} />}
              options={companyMembers || []}
            />
          </InputGroup>
        </InputContainer>
        <Typography variant="subtitle1" style={{ marginTop: 16, fontWeight: 'bold' }}>
          People with access
        </Typography>

        {group.members?.map((user, index) => (
          <UserAccessItem
            handleRoleChange={handleRoleChange}
            handleRemoveUser={removeMember}
            index={index}
            user={user}
            key={user?._id}
          />
        ))}
      </StyledDialogContent>
      <StyledDialogActions>
        <StyledButton onClick={onClose} className="cancelButton" disabled={loading}>
          Cancel
        </StyledButton>
        <StyledButton
          onClick={handelCreateGroupConfirm}
          className="confirmButton"
          disabled={loading}>
          {loading ? <AnimatedDotsText text="Creating" /> : 'Confirm'}
        </StyledButton>
      </StyledDialogActions>
    </StyledDialog>
  );
}

export default CreateGroupModal;
